import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/css/font.css";
import ToseeAdmin from "./container/ToseeAdmin";
import { BrowserRouter } from "react-router-dom";
import "./assets/css/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import MainContext from "./context/mainContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MainContext>
        <ToseeAdmin />
      </MainContext>
    </BrowserRouter>
    <ToastContainer />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
